import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IContactEntityActionModel } from '@apps-common/types/portal/contact'

export const QUERY_KEY_PORTAL_GET_CONTACT_ENTITY_ACTIONS = (entityId: string) => ['getContactEntityActions', entityId]

export const getContactEntityActions = async (entityId: string): Promise<IContactEntityActionModel[]> =>
  axios.get(`/general/getactions?id=${entityId}`).then((res) => res.data?.data)

type QueryFnType = typeof getContactEntityActions

type Props = {
  config?: QueryConfig<QueryFnType>
  entityId: string
}

export const useGetContactEntityActions = ({ config, entityId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_PORTAL_GET_CONTACT_ENTITY_ACTIONS(entityId),
    queryFn: () => getContactEntityActions(entityId)
  })
